import { render, staticRenderFns } from "./TheEventGameSchedule.vue?vue&type=template&id=2c6d86f3&scoped=true"
import script from "./TheEventGameSchedule.vue?vue&type=script&lang=js"
export * from "./TheEventGameSchedule.vue?vue&type=script&lang=js"
import style0 from "./TheEventGameSchedule.vue?vue&type=style&index=0&id=2c6d86f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d86f3",
  null
  
)

export default component.exports